import { httpRequest } from "@/axios/axios-api";

export default {
  data() {
    return {
      chapterContent: { name: "", picList: [] }
    };
  },
  created: function() {
    // 加载课程列表
    this.loadCourseList();
  },
  methods: {
    async loadCourseList() {
      const loadingInstance = this.$loading({ text: "加载中" });
      const res = await httpRequest(
        "/app/course/rich/" + this.$route.query.rtcId,
        "get",
        null
      );
      if (res !== null && res !== undefined && res.code === 200) {
        this.chapterContent = res.data;
      }
      loadingInstance.close();
    },
    go2CourseContentPage(rtcId) {
      this.$route.push({ path: "/courseContent", query: { rtcId: rtcId } });
    }
  }
};
